(() => {
  const selector = '.gpo-form__group.gpo-col-12[data-element-id="select-1"]';

  const removeTarget = () => {
    document.querySelectorAll(selector).forEach(el => el.remove());
  };

  removeTarget();

  const observer = new MutationObserver(() => {
    removeTarget();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  // Change from Clear Plus to CLEAR+
  const FROM = /clear\s*plus/gi;
  const TO = "CLEAR+";
  const ROOT = document.body;

  const replaceInTextNode = (node) => {
    const text = node.nodeValue;
    if (!text || !FROM.test(text)) return;
    FROM.lastIndex = 0;
    node.nodeValue = text.replace(FROM, TO);
  };

  const walkAndReplace = (root) => {
    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: (node) => {
          if (!node.nodeValue || !FROM.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;
          FROM.lastIndex = 0;
          const p = node.parentNode;
          if (!p) return NodeFilter.FILTER_REJECT;
          const tag = p.nodeName;
          if (tag === "SCRIPT" || tag === "STYLE" || tag === "NOSCRIPT" || tag === "TEXTAREA") {
            return NodeFilter.FILTER_REJECT;
          }
          return NodeFilter.FILTER_ACCEPT;
        },
      }
    );

    const nodes = [];
    let n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(replaceInTextNode);
  };

  walkAndReplace(ROOT);

  const obs = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === "characterData") {
        replaceInTextNode(m.target);
      } else if (m.type === "childList") {
        m.addedNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) replaceInTextNode(node);
          else if (node.nodeType === Node.ELEMENT_NODE) walkAndReplace(node);
        });
      }
    }
  });

  obs.observe(ROOT, { childList: true, subtree: true, characterData: true });
})();
